import type { FrontendWidget } from '../types';
import { CardSectionComponent } from './CardSectionComponent';
import type { CardSectionConfig, CardSectionResolved } from './types';

export const cardSectionWidget: FrontendWidget<
  CardSectionConfig,
  CardSectionResolved
> = {
  componentType: 'layouts.card-section',
  // 70.14: SlotRenderer adds no container — a section container — it paints its own card and contains its blocks.
  layout: 'self',
  displayName: 'Card Section',
  defaultValues: { background: 'sand', blocks: [] },
  ComponentA: CardSectionComponent,
  resolveSync: (config) => ({
    background: config.background,
    hideOnMobile: config.hideOnMobile ?? false,
    blocks: config.blocks ?? [],
  }),
};
